<template>
    <div>
        <v-progress-linear
            style="width:100%"
            :reverse="reverse"
            :value="value"
            :indeterminate="indeterminate"
            :rounded="rounded"
            :height="height"
            :color="color">
        </v-progress-linear>
    </div>
</template>
<script>
export default {
name: 'BeeProgressCircular',
props:["value","color", "reverse", "rounded", "indeterminate", "height"],
}
</script>